import { generatePath as _generatePath } from 'react-router-dom';
import { Employee } from '@/containers/HoursByDay/types';
import { Position } from '@/globalTypes';

export const djangoUrls = {
  'invoice:pdf': '/invoice/pdf/:invoice_pk/',
  'manager_ui:employee.list.ajax': '/manager/employee/list/ajax/',
  'manager_ui:employee.tracking.ajax':
    '/manager/employee/tracking/:employee_pk/ajax/:year/:week/',
  'manager_ui:employee.tracking.by_day.ajax':
    '/manager/employee/tracking/ajax/:year/:month/:day/',
  'manager_ui:employee.tracking.create':
    '/manager/employee/tracking/:employee_pk/create/',
  'manager_ui:invoice.approve': '/manager/invoice/:invoice_pk/approve/',
  'manager_ui:invoice.create': '/manager/invoice/create/',
  'manager_ui:invoice.delete': '/manager/invoice/:invoice_pk/delete/',
  'manager_ui:invoice.send': '/manager/invoice/:invoice_pk/send/',
};

// TODO: Remove any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const generatePath = (url: string, params: any) =>
  _generatePath(url, params) + '/';

export const ajaxRoutes = {
  login: '/manager/api/v0/login/',
  logout: '/manager/logout/',
  property: '/manager/property/selection/',
  propertiesList: '/manager/properties-list/ajax/',
  propertiesListV0: '/manager/api/v0/manager/properties/',
  changePassword: '/manager/api/v0/change_password/',
  forgotPassword: '/manager/forgot-password/',
  lastPhoneDigits: '/manager/phone-last-digits/',
  requestEmployeeList: '/manager/employee/request_employee/',
  requestEmployeeDelete: (id: number) =>
    '/manager/employee/request_employee/' + id + '/',
  invoiceList: (page: number) => `/manager/invoice/list/ajax/?page=${page}`,
  invoiceCreate: () => djangoUrls['manager_ui:invoice.create'],
  invoiceDelete: (id: number | null) =>
    generatePath(djangoUrls['manager_ui:invoice.delete'], {
      invoice_pk: id ?? 0,
    }),
  invoicePdf: (id: number | null) =>
    generatePath(djangoUrls['invoice:pdf'], { invoice_pk: id ?? 0 }),
  invoiceSend: (id: number | null) =>
    generatePath(djangoUrls['manager_ui:invoice.send'], {
      invoice_pk: id ?? 0,
    }),
  invoiceApprove: (id: number | null) =>
    generatePath(djangoUrls['manager_ui:invoice.approve'], {
      invoice_pk: id ?? 0,
    }),
  invoiceEmailRecepients: (invoiceId) =>
    `/manager/invoice-email-recipients/${invoiceId}/`,
  employeeList: () => djangoUrls['manager_ui:employee.list.ajax'],
  employeePositionsList: '/manager/positions/',
  // TODO: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  employeeUpdate: (id: any) => `/manager/employee/update/${id}/`,
  employeeCreate: '/manager/employee/create/',
  // TODO: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  employeeTrackingByDay: ({ day, month, year }: any) =>
    generatePath(djangoUrls['manager_ui:employee.tracking.by_day.ajax'], {
      day: day,
      month: month,
      year: year,
    }),
  // TODO: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  employeeTrackingList: ({ id, week, year }: any) =>
    generatePath(djangoUrls['manager_ui:employee.tracking.ajax'], {
      employee_pk: id,
      week: week,
      year: year,
    }),

  employeeTrackingCreate: (id: number) =>
    generatePath(djangoUrls['manager_ui:employee.tracking.create'], {
      employee_pk: id ?? 0,
    }),
  employeeTrackingUpdate: (id: number) =>
    `/manager/employee/tracking/${id}/update/`,
  employeeTrackingDelete: (id: number) =>
    `/manager/employee/tracking/${id}/delete/`,
  employeeTrackingArchive: (id: number) =>
    `/manager/employee/tracking/${id}/archive/`,
  employeeTrackingRestore: (id: number) =>
    `/manager/employee/tracking/${id}/restore/`,
  employeeManualCheckIn: (id: number) =>
    `/manager/employee/tracking/${id}/auto_clockin/`,
  employeeManualCheckOut: (id: number) =>
    `/manager/employee/tracking/${id}/auto_clockout/`,
  employeeCommentList: (id: number) => `/manager/employee/comments/${id}/`,
  employeeCommentCreate: (id) => `/manager/employee/comments/${id}/create/`,
  employeeBlock: (id) => `/manager/block-employee/${id}/`,
  employeeUnBlock: (id) => `/manager/employee/unblock/${id}/`,
  employeeSendMessage: (id) => `/manager/employee/message/${id}/`,
  employeeSendLink: (id) => `/manager/api/v0/employee/reset_code/${id}/`,
  serverTime: '/manager/server-time/',
  turnOverList: ({ from, to }) =>
    `/manager/turn-over-tab/?date_from=${from}&date_to=${to}`,
};
